<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    menu-props="offsetY"
    top
  >
    <a
      slot="activator"
      class="title"
    >...</a>
    <v-card>
      <v-data-table
        id="table-frame"
        ref="table-frame"
        :headers="headers"
        :items="items"
        hide-actions
        no-data-text="Нет данных"
        style="height: 100%"
        class="v-data-table--fixed-header v-data-table--fixed-footer"
      >
        <template
          slot="headers"
          slot-scope="props"
        >
          <tr style="height: 35px">
            <th
              v-for="header in props.headers"
              :key="header.text"
            >
              <span>{{ header.text }}</span>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <td>
            <v-tooltip
              v-if="props.item.category"
              top
            >
              <template v-slot:activator="{ on }">
                <span
                  class="mx-4"
                  v-on="on"
                > {{ props.item.category.title }}

                </span>
              </template>
              <span>{{ props.item.category.title }}</span>
            </v-tooltip>
            <span
              v-else
              class="mx-4"
            >
              {{ props.item.category.title }}
            </span>
          </td>
          <td>
            <span class="mx-4">
              {{ props.item.weightBrutto | fixedNumber(3) }}
            </span>
          </td>
          <td>
            <span class="mx-4">
              {{ props.item.volume | fixedNumber(3) }}
            </span>
          </td>
          <td>
            <span class="mx-4">
              {{ props.item.cargoPlaces }}
            </span>
          </td>
        </template>
        <template slot="footer">
          <td class="footer-table-cell">
            <strong class="mx-4">Итого:</strong>
          </td>
          <td
            :class="[
              'footer-table-cell',
              isDifferentSumOfWeightBrutto ? 'red--text' : '',
              'mx-2' ]"
          >
            <span class="mx-4">
              {{
                $options.filters.separateDigits(
                  sumOfWeightBrutto.toFixed("3").replace(".", ",")
                )
              }}
            </span>
          </td>
          <td
            :class="[
              'footer-table-cell',
              isDifferentSumOfVolume ? 'red--text' : ''
            ]"
          >
            <span class="mx-4">
              {{
                $options.filters.separateDigits(
                  sumOfVolume.toFixed("3").replace(".", ",")
                )
              }}
            </span>
          </td>
          <td
            :colspan="2"
            :class="[
              'footer-table-cell',
              isDifferentSumOfCargoPlaces ? 'red--text' : ''
            ]"
          >
            <span class="mx-4">
              {{ sumOfCargoPlaces }}
            </span>
          </td>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          small
          flat
          @click="menu = false"
        >
          Закрыть
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  props: ["id"],
  data() {
    return {
      headers: [
        { value: "category", text: "Категория товара", sortable: false },
        { value: "volume", text: "Вес брутто, кг", sortable: false },
        { value: "weightBrutto", text: "Объем, м3", sortable: false },
        { value: "cargoPlaces", text: "Всего мест", sortable: false },
        { value: "add", text: "", type: "icon", sortable: false },
      ],
      menu: false,
    };
  },
  computed: {
    items() {
      return this.$store.getters["shipping/categoriesInfo"];
    },
    sumOfVolume() {
      if (!this.items.length) {
        return 0;
      }
      return this.items.reduce(function(sum, current) {
        return sum + current.volume;
      }, 0);

    },
    sumOfWeightBrutto() {
      if (!this.items.length) {
        return 0;
      }
      return this.items.reduce(function(sum, current) {
        return sum + current.weightBrutto;
      }, 0);
    },
    sumOfCargoPlaces() {
      if (!this.items.length) {
        return 0;
      }
      return this.items.reduce(function(sum, current) {
        return sum + current.cargoPlaces;
      }, 0);
    },
    isDifferentSumOfVolume() {
      return (
        this.totalInfo?.totalVolume.toFixed(3) !== this.sumOfVolume.toFixed(3)
      );
    },
    isDifferentSumOfWeightBrutto() {
      return (
        this.totalInfo?.totalWeightBrutto.toFixed(3) !==
          this.sumOfWeightBrutto.toFixed(3)
      );
    },
    isDifferentSumOfCargoPlaces() {
      return this.totalInfo?.totalCargoPlaces !== this.sumOfCargoPlaces;
    },
    totalInfo() {
      return {
        totalCargoPlaces: this.items.reduce(function(sum, current) {
          const result = sum + current.cargoPlaces;
          return +result.toFixed(3);
        }, 0),
        totalVolume: this.items.reduce(function(sum, current) {
          const result = sum + current.volume;
          return +result.toFixed(3);
        }, 0),
        totalWeightBrutto: this.items.reduce(function(sum, current) {
          const result = sum + current.weightBrutto;
          return +result.toFixed(3);
        }, 0),
      };
    },
  },
};
</script>

<style scoped>
a {
  color: inherit;
}
</style>